import React  from 'react';
import TotalComponentProto from "./total-proto";

export default function renderListInView(props) {
    return <TotalComponentProto renderMode="view" {...props} />;
}